import { useContext } from 'react';

import { GaugeChartRangeMaxContext } from '../contexts/GaugeChartRangeMaxContext.js';

export const useGaugeChartRangeMaxContext = () =>
  useContext(GaugeChartRangeMaxContext);
